import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { AppSidebar } from "./AppSidebar";
import {
  MOBILE_BOTTOM_NAV_HEIGHT,
  MobileBottomNav,
} from "./MobileBottomNav";
import { isEmbeddedMode } from "app/utils/auth";
import { useEmbeddedViewportHeight } from "app/hooks/useEmbeddedViewportHeight";
import { useMobileLayout } from "app/hooks/useMobileLayout";

function DesktopAppLayout() {
  const embedded = isEmbeddedMode();

  React.useEffect(() => {
    if (!embedded) {
      return;
    }
    document.documentElement.classList.add("delivery-dashboard-embedded");
    return () => {
      document.documentElement.classList.remove("delivery-dashboard-embedded");
    };
  }, [embedded]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "stretch",
        gap: 0,
        width: "100%",
        height: "100%",
        minHeight: embedded ? "-webkit-fill-available" : "100dvh",
        maxHeight: embedded ? "none" : "100dvh",
        bgcolor: "#f5f6fa",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          py: 1.5,
          pl: 0,
          pr: 0,
          boxSizing: "border-box",
        }}
      >
        <AppSidebar />
      </Box>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

function MobileAppLayout() {
  const embedded = isEmbeddedMode();
  useEmbeddedViewportHeight();

  React.useEffect(() => {
    if (!embedded) {
      return;
    }
    document.documentElement.classList.add("delivery-dashboard-embedded");
    return () => {
      document.documentElement.classList.remove("delivery-dashboard-embedded");
    };
  }, [embedded]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        flex: 1,
        minHeight: 0,
        maxHeight: embedded
          ? "var(--embedded-viewport-height, 100%)"
          : "100%",
        bgcolor: "#f5f6fa",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          pb: MOBILE_BOTTOM_NAV_HEIGHT,
          boxSizing: "border-box",
        }}
      >
        <Outlet />
      </Box>
      <MobileBottomNav />
    </Box>
  );
}

export function AppLayout() {
  const isMobile = useMobileLayout();
  return isMobile ? <MobileAppLayout /> : <DesktopAppLayout />;
}
